import React from 'react';
import CommonFourthStep from '../CommonFourthStep';

function FourthStep(props) {
  return (
    <CommonFourthStep
      reportType="LVT"
      props={props}
    />
  );
}

export default FourthStep;
